<script>
import ManageAllocationModalForm from '../ManageAllocationModalForm/ManageAllocationModalForm.vue';
import ManageAllocationModalList from '../ManageAllocationModalList/ManageAllocationModalList.vue';
import ManageAllocationModalOverlay from '../ManageAllocationModalOverlay/ManageAllocationModalOverlay.vue';
import {mapState, mapActions, mapGetters} from 'vuex';

export default {
    components: {
        ManageAllocationModalForm,
        ManageAllocationModalList,
        ManageAllocationModalOverlay
    },
    computed: {
        ...mapState({
            open: state => state.allocation.modal.open,
            from: state => state.allocation.calendar.from,
            to: state => state.allocation.calendar.to,
            error : state => state.allocation.form.allocations.error,
            errorMessage : state => state.allocation.form.allocations.text,
            validationError: state => state.allocation.form.validator.error,
            success: state => state.allocation.modal.success,
            blocked: state => state.allocation.modal.blocked,
            overlaySuccess: state => state.allocation.modal.overlay.success,
            overlayFailure: state => state.allocation.modal.overlay.error,
            overlayMessage: state => state.allocation.modal.overlay.message,
            adding: state => state.allocation.modal.adding,
            loading: state => state.allocation.allocations.loading
        }),
        ...mapGetters({
            allocationsInPeriod: 'allocation/allocationsInPeriodPaginated',
            allotmentInPeriod: 'allocation/allotmentInPeriod'
        })
    },
    created() {
        window.addEventListener('keyup', this.keyPress);
    },
    methods: {
        ...mapActions({
            toggleModal: 'allocation/toggleModal',
            toggleAddAllocation: 'allocation/toggleModalAddAllocations'
        }),
        toggle($event) {
            if ($event.target.id === 'container') {
                this.toggleModal();
            }
        },
        keyPress(key) {
            if(key.key === 'Escape' && this.open) {
                this.toggleModal();
            }
        }
    }
}
</script>

<template>
    <div v-if="open" class="manage-allocation-modal" @click="toggle($event)">
        <div id="container" class="manage-allocation-modal__container">
            <div class="manage-allocation-modal__content">
                <div class="manage-allocation-modal__header">
                    <div class="manage-allocation-modal__heading">
                        {{ $t('manageAllocationModal.header.heading') }}
                    </div>
                    <div class="manage-allocation-modal__toggle" @click="toggleModal">
                        <i class="fa fa-times-circle"/>
                    </div>
                </div>
                <div class="manage-allocation-modal__body">
                    <div v-if="(allocationsInPeriod.length === 0 || !allotmentInPeriod) && !loading" class="manage-allocation-modal__title">
                        {{ $t('manageAllocationModal.noAllocations') }}
                    </div>
                    <div v-if="allocationsInPeriod.length > 0 && allotmentInPeriod" class="manage-allocation-modal__title">
                        {{ $t('manageAllocationModal.allocations') }}
                    </div>
                    <div v-if="loading" class="manage-allocation-modal__title">
                        {{ $t('manageAllocationModal.loading') }}
                    </div>
                    <div class="manage-allocation-modal__period">
                        {{ $t('manageAllocationModal.period') }} {{ from }} {{ $t('manageAllocationModal.dash') }} {{ to }}
                    </div>
                    <div v-if="allocationsInPeriod.length === 0" class="manage-allocation-modal__no-allocations">
                        <div v-if="!adding && !loading" class="manage-allocation-modal__add">
                            <button class="manage-allocation-modal__add-btn" @click="toggleAddAllocation()">
                                {{ $t('manageAllocationModal.buttons.add') }}
                            </button>
                        </div>
                        <div class="manage-allocation-modal__info">
                            <span v-html="$t('manageAllocationModal.info')"/>
                        </div>
                    </div>
                    <manage-allocation-modal-form v-if="adding"/>
                    <manage-allocation-modal-overlay/>
                    <div v-if="allocationsInPeriod.length > 0" class="manage-allocation-modal__allocations">
                        <manage-allocation-modal-list/>
                    </div>
                    <div v-if="success && !validationError" class="manage-allocation-modal__success">
                        {{ $t('manageAllocationModal.success') }}
                    </div>
                    <div v-if="blocked && !validationError" class="manage-allocation-modal__success">
                        {{ $t('manageAllocationModal.blocked') }}
                    </div>
                    <div v-if="overlaySuccess || overlayFailure" :class="'manage-allocation-modal__' + overlayMessage.level" class="manage-allocation-modal__alert">
                        {{ $t( overlayMessage.text ) }}
                    </div>
                    <div v-if="error" class="manage-allocation-modal__error">
                        {{ $t(errorMessage) }}
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>



// WEBPACK FOOTER //
// src/components/ManageAllocationModal/ManageAllocationModal.vue